// extracted by mini-css-extract-plugin
export default {"header":"Questionnaire_header__DlczD","text":"Questionnaire_text__G7dDg","quesioner-box":"Questionnaire_quesioner-box__k5eCr"};